export default __webpack_public_path__ + "static/media/refreshIcon.cd0bb3e1.png";